var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-text-field',{attrs:{"validation-rule":"surname","label":"Nachname","required":_vm.required,"disabled":_vm.disabled,"autofocus":true},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}})}
var staticRenderFns = []

export { render, staticRenderFns }